/**
 * Created by rcabr on 6/23/2016.
 */

angular.module('eStories.device.model', [
        /*eStories device model*/
    ])
    .service('DeviceModel', ['WS', function (WS) {

        this.getDeviceList = function () {
            return WS.callServer('device/getDeviceList', {});
        };

        this.disconnectDevice = function (deviceId) {
            return WS.callServer('device/disconnectDevice', {deviceId: deviceId});
        };

        this.getDeviceType = function (deviceType) {
            switch (deviceType) {
                case 'IPAD':
                    return 'iPad';
                case 'IPHONE':
                    return 'iPhone';
                case 'IPOD' :
                    return 'iPod';
                default:
                    return deviceType.toLowerCase().replace('_', ' ').replace(/\b[a-z]/g, function (f) {
                        return f.toUpperCase();
                    });
            }
        };

        this.getDevicePlatform = function (platform) {
            return platform.toLowerCase().replace(/\b[a-z]/g, function (f) {
                return f.toUpperCase();
            });
        };

        this.getDeviceIcon = function (platform) {
            switch (platform) {
                case 'MOBILE':
                    return 'mobileDevice';
                case 'WEB':
                    return 'desktopDevice';
                case 'TABLET':
                    return 'tabletDevice';
            }
        };

    }]);
